import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode, Ref } from "react";
import { classes } from "../../nucleo/classes";

/**
 * O resto das props vai para o `<section>`, e é o que permite a um cartão carregar o próprio
 * estado como atributo — `data-estado`, `data-testid`. Chip e Aviso já fazem isso pelo mesmo
 * motivo: cor sozinha não serve nem para quem não a enxerga nem para o teste automatizado, e um
 * cartão cujo estado só existe na cor do chip não é legível por nenhum dos dois.
 */
export interface PropsDoCartao extends HTMLAttributes<HTMLElement> {
  titulo?: ReactNode;
  /** Selo, chip ou botão alinhado à direita do título. */
  acessorio?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** A `<section>` de verdade, para quem precisa rolar até o cartão — como `Campo` já expõe a sua. */
  ref?: Ref<HTMLElement>;
}

export function Cartao({ titulo, acessorio, children, className, ...resto }: PropsDoCartao) {
  return (
    <section className={classes("cartao", className)} {...resto}>
      {titulo || acessorio ? (
        <header className="flex flex-wrap items-start justify-between gap-3 mb-2">
          {titulo ? <h3 className="cartao__titulo">{titulo}</h3> : <span />}
          {acessorio}
        </header>
      ) : null}
      {children}
    </section>
  );
}

export interface PropsDoCartaoAcionavel
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  titulo: ReactNode;
  descricao?: ReactNode;
}

/** Cartão que é um botão de verdade — teclado e leitor de tela incluídos. */
export function CartaoAcionavel({
  titulo,
  descricao,
  className,
  type = "button",
  ...resto
}: PropsDoCartaoAcionavel) {
  return (
    <button
      type={type}
      className={classes("cartao cartao--acionavel", className)}
      {...resto}
    >
      <span className="cartao__titulo block">{titulo}</span>
      {descricao ? <span className="cartao__texto block">{descricao}</span> : null}
    </button>
  );
}
